<template>
  <div class="logo-container">
    <svg class="logo-svg" viewBox="0 0 280 70" xmlns="http://www.w3.org/2000/svg">
      <!-- 雨滴图形 - 继续向上移动 -->
      <path class="rain-drop"
            d="M55 0 C55 0, 70 30, 55 45 C40 60, 25 45, 25 30 C25 15, 40 0, 55 0"
            fill="#1890ff" />

      <!-- 文字：雨瑞 - 继续向上移动 -->
      <text x="85" y="32" class="logo-text">雨瑞资源网</text>
    </svg>
  </div>
</template>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  height: 42px;
}

.logo-svg {
  height: 100%;
  width: auto;
  display: block;
}

.rain-drop {
  animation: dropFloat 3s ease-in-out infinite;
}

.logo-text {
  font-size: 36px;
  font-weight: bold;
  fill: #333;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  dominant-baseline: middle;
}

@keyframes dropFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(2.5px);
  }
}
</style>
